// extracted by mini-css-extract-plugin
module.exports = {"pnp_container":"RegisterBtnManager_pnp_container__BYqRy"};